<button
  class="icon-filter-button"
  mat-stroked-button
  [matMenuTriggerFor]="filterSelection"
  matBadgePosition="after"
  matBadgeColor="accent"
  [ngClass]="{ 'filter-selected-view': selectedFilter }"
>
  <mat-icon class="icon">filter_list</mat-icon>
  <span class="label">
    {{ 'MEETING_SCHEDULER.MEETING_LIST.Filter_LABEL' | translate }}
  </span>
</button>

<mat-menu class="dropdown-menu" [overlapTrigger]="false" #filterSelection="matMenu">
  <div cdkFocusInitial mat-menu-item class="hide-item"></div>
  <!-- Prevent first item from being auto-focused -->
  <button
    *ngFor="let option of displayedMeetingTypes"
    [ngClass]="{ 'selected-item': selectedFilter === option.id }"
    mat-menu-item
    (click)="onselectionchange(option.id)"
  >
    <div class="dropdown-menu-item">
      <span> {{ option.displayName }} </span>
      <mat-icon *ngIf="selectedFilter === option.id">done</mat-icon>
    </div>
  </button>
</mat-menu>

<mat-chip-listbox>
  <ng-container *ngFor="let option of displayedMeetingTypes">
    <mat-chip-option *ngIf="selectedFilter === option.id">
      {{ option.name }}
      <button matChipRemove aria-label="Remove option" (click)="onselectionchange('all')">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-option>
  </ng-container>
</mat-chip-listbox>
